var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',[_c('h3',{staticClass:"text-center"},[_vm._v("Recepciones")])]),_c('apexchart',{attrs:{"width":"500","type":"bar","options":_vm.options,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }